module.exports = __webpack_public_path__ + "static/media/magic.a1679523.svg";